import { TagDto } from "./tagDto";
import { AddressDto } from "./addressDto";

export class CustomerDetailDto {
	public customerId: number = 0;
	public beruflichePosition: string = "";
	public branche: string = "";
	public cad: string = "";
	public wieAufmerksamGeworden: string = "";
	public eindruck: string = "";
	public vorteil: string = "";
	public bemerkung: string = "";
	public alternativeBlechlieferanten: string = "";
	public angerufenAm: string = "";
	public technologie: string = "";
	public naechsterSchritt: string = "";
	public losgroessen: string = "";
	public anforderungLieferzeit: string = "";
	public wuensche: string = "";
	public fachzeitschrift: string = "";
	public creditLimit: number = 0;
	public prepaymentRequired: boolean = false;
	public active: boolean = true;
	public tags: TagDto[] = new Array<TagDto>();
	public deliveryAddresses: Array<AddressDto> = new Array<AddressDto>();
	public invoiceAddresses: Array<AddressDto> = new Array<AddressDto>();
}
